import { Guid } from "typescript-guid";
import { watch } from "vue";
import { getToken, useCustomerIdRef } from "../api";
import { Api, type RequestParams } from "../opengl-api-models";

const openGlHttpClient = new Api({
	baseApiParams: {
		secure: true,
		headers: useCustomerIdRef().value
			? { "X-Organization-Id": useCustomerIdRef().value }
			: {},
	},
	securityWorker: async () => {
		const headers: Record<string, string> = {
			Authorization: `Bearer ${await getToken()}`,
			"X-Request-Id": Guid.create().toString(),
		};

		return { headers };
	},
});

watch(
	useCustomerIdRef(),
	accountId => {
		if (!accountId) return;
		(
			openGlHttpClient as unknown as { baseApiParams: RequestParams }
		).baseApiParams.headers = {
			"X-Organization-Id": accountId ?? "",
		};
	},
	{ immediate: true },
);

export const initOpenGlClient = (defaultUrl: string) => {
	openGlHttpClient.baseUrl = `${defaultUrl}`;
};

export const useOpenGlHttp = (): Api<unknown> =>
	openGlHttpClient as Api<unknown>;
